import Api from "@/services/api";
import { ActionContext } from "vuex";
import {
  getPmLocalOverview,
  getYearlyOverview,
  getMonthlyOverview,
} from "@/services/endpoints";
import moment from "moment";
import { formatAmount } from "@/services/helpers";
export default {
  namespaced: true,
  state: {
    currentPage: 1,
    totalPages: null,
    totalData: null,
    allExpenses: [],
    addExpense: false,
    allOverviews: [],
    appLoading: false,
    totalsOverview: [],
    defaultCurrency: null,
    overViewStartDate: null,
    overViewEndDate: null,
    allBalanceInfoData: [],
    projectDetails: null,
    lockingAndApprovingInfo: {},
    totalLockingAndApprovingInfo: [],
  },
  mutations: {
    SET_PROJECT_DETAILS_TO_STATE(state: any, payload: any) {
      state.projectDetails = payload;
    },
    SET_CHEQUES_TO_STATE(state: any, payload: any) {
      state.allExpenses = payload;
    },
    SET_CURRENT_PAGE_TO_STATE(state: any, payload: any) {
      state.currentPage = payload;
    },
    SET_TOTAL_PAGES_TO_STATE(state: any, payload: any) {
      state.totalPages = payload;
    },
    SET_TOTAL_DATA_TO_STATE(state: any, payload: any) {
      state.totalData = payload;
    },
    SET_ADD_EXPENSE_TO_STATE(state: any, payload: any) {
      state.addExpense = payload;
    },
    SET_ALL_OVERVIEWS_TO_STATE(state: any, payload: any) {
      state.allOverviews = payload;
    },
    SET_APP_LOADING_TO_STATE(state: any, payload: any) {
      state.appLoading = payload;
    },
    SET_TOTALS_OVERVIEW_TO_STATE(state: any, payload: any) {
      state.totalsOverview = payload;
    },
    SET_DEFAULT_CURRENCY_TO_STATE(state: any, payload: any) {
      state.defaultCurrency = payload;
    },
    SET_OVERVIEW_START_DATE_TO_STATE(state: any, payload: any) {
      state.overViewStartDate = payload;
    },
    SET_OVERVIEW_END_DATE_TO_STATE(state: any, payload: any) {
      state.overViewEndDate = payload;
    },
    SET_ALL_BALANCE_INFO_DATA_TO_STATE(state: any, payload: any) {
      state.allBalanceInfoData = payload;
    },
    SET_LOCKING_AND_APPROVING_INFO_TO_STATE(state: any, payload: any) {
      state.lockingAndApprovingInfo = payload;
    },
    SET_TOTAL_LOCKING_AND_APPROVING_INFO_TO_STATE(state: any, payload: any) {
      state.totalLockingAndApprovingInfo = payload;
    }
  },
  getters: {
    isProjectDetails(state: any) {
      return state.projectDetails
    },
    isAllExpenses(state: any) {
      return state.allExpenses;
    },
    isCurrentPage(state: any) {
      return state.currentPage;
    },
    isTotalPages(state: any) {
      return state.totalPages;
    },
    isTotalData(state: any) {
      return state.totalData;
    },
    isAddExpense(state: any) {
      return state.addExpense;
    },
    isAllOverviews(state: any) {
      return state.allOverviews;
    },
    appLoading(state: any) {
      return state.appLoading;
    },
    isTotalsOverview(state: any) {
      return state.totalsOverview;
    },
    isDefaultCurrency(state: any) {
      return state.defaultCurrency;
    },
    isOverViewStartDate(state: any) {
      return state.overViewStartDate;
    },
    isOverViewEndDate(state: any) {
      return state.overViewEndDate;
    },
    isAllBalanceInfoData(state: any) {
      return state.allBalanceInfoData;
    },
    getLockingAndApprovingInfo(state: any) {
      return state.lockingAndApprovingInfo;
    },
    getTotalLockingAndApprovingInfo(state: any) {
      return state.totalLockingAndApprovingInfo
    }

    // isIndividualBalanceInfoData(state: any) {
    //   return state.individualBalanceInfoData;
    // }
  },
  actions: {
    async getAllPmLocalOverviews(context: ActionContext<any, any>, payload: any) {
      try {
        if (payload.load_page) {
          context.commit("SET_APP_LOADING_TO_STATE", true);
        }
        const response = await Api()
          .post(
            `${getPmLocalOverview}${payload.projectId}/${payload.foreignEstablishmentId}/`,
            { currency: payload.currency }
          )
        if (response) {
          context.commit("SET_APP_LOADING_TO_STATE", false);
          context.commit("SET_PROJECT_DETAILS_TO_STATE", response.data?.data?.project_details);
          context.commit(
            "SET_OVERVIEW_START_DATE_TO_STATE",
            response.data?.data?.project_details?.project_start_date
          );
          context.commit(
            "SET_OVERVIEW_END_DATE_TO_STATE",
            response.data?.data?.project_details?.project_end_date
          );

          const transformedData = response.data?.data?.budget_overview?.map(
            (item: any) => {
              return {
                ...item,
                ...item.yearly_data
              };
            }
          );
          const transformedBottomData = response.data?.data?.bottom_data?.map(
            (item: any) => {
              return {
                ...item,
                ...item.yearly_data
              };
            }
          );

          const allOverviewData = [...transformedData, ...transformedBottomData];

          context.commit("SET_ALL_OVERVIEWS_TO_STATE", allOverviewData);
          context.commit("SET_TOTAL_LOCKING_AND_APPROVING_INFO_TO_STATE", response.data.locking_and_approval_info || {});
        }
      } catch (error) {
        if (error) {
          context.commit("SET_APP_LOADING_TO_STATE", false);
        }
      }
    },
    async getPmLocalYearOverviews(context: ActionContext<any, any>, payload: any) {
      try {
        if (payload.load_page) {
          context.commit("SET_APP_LOADING_TO_STATE", true);
        }
        const response = await Api()
          .post(
            `${getYearlyOverview}${payload.projectId}/${payload.foreignEstablishmentId}/`,
            {
              year: payload.year,
              expense_type: payload.expense_type,
              currency: payload.currency,
            }
          )

        if (response) {
          context.commit("SET_ALL_BALANCE_INFO_DATA_TO_STATE", response.data);
          const allYearlyData = [...response.data.overview_data, ...response.data.bottom_data];
          context.commit("SET_ALL_OVERVIEWS_TO_STATE", allYearlyData);
          context.commit("SET_LOCKING_AND_APPROVING_INFO_TO_STATE", response.data.locking_and_approval_info || {});
        }
      } catch (error) {
        if (error) {
          console.error("error:::", error);
        }
      } finally {
        context.commit("SET_APP_LOADING_TO_STATE", false);
      }
    },
    async getPmLocalMonthlyOverviews(context: ActionContext<any, any>, payload: any) {
      try {
        if (payload.load_page) {
          context.commit("SET_APP_LOADING_TO_STATE", true);
        }
        const response = await Api()
          .post(
            `${getMonthlyOverview}${payload.projectId}/${payload.foreignEstablishmentId}/`,
            {
              month: payload.month,
              year: payload.year,
              expense_type: payload.expense_type,
              currency: payload.currency,
            }
          )
        if (response) {
          const allMonthlyData = response.data.overview_data?.length > 0 ? [...response.data.overview_data, ...response.data.bottom_data] : [];
          context.commit("SET_ALL_BALANCE_INFO_DATA_TO_STATE", response.data);
          context.commit("SET_ALL_OVERVIEWS_TO_STATE", allMonthlyData);
        }
      } catch(error) {
        if (error) {
          console.error("error::", error)
          throw error
        }
      } finally {
        context.commit("SET_APP_LOADING_TO_STATE", false);
      }
    },
  },
};
